import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {
  Exemption_4_5,
} from '@portbase/bezoekschip-service-typescriptmodels';
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";

@Component({
    selector: 'app-visit-exemptions-exemption-4-5',
    templateUrl: './exemption_4_5.component.html',
    styleUrls: ['./exemption_4_5.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Exemption_4_5Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_4_5;

  OTHER: string = 'Other';

  locationTypes: string[] = ['',
    'Superstructure',
    "Aft",
    'In loading zone',
    'In engine room',
    'Foredeck'
  ];

  activityTypes: string[] = ['',
    'Repair with open flame / heat',
    'Repair without flame or heat',
    'Underwater work, screw polishing, underwater brushing'
  ];

  executorTypes: string[] = ['',
    'Own crew',
    this.OTHER
  ];

  fuelTypes: string[] = ['',
    'Ammonia',
    'LNG',
    'Methanol',
    'Hydrogen',
    'Conventional Fuels',
    this.OTHER
  ];

  resetExecutorTypeOther() {
    this.exemption.executorTypeOther = '';
  }

  resetFuelTypeOther() {
    this.exemption.fuelTypeOther = '';
  }

  resetFieldsRelateToWorkOnInstallationOrOnTank() {
    this.exemption.fuelOnBoard = null;
    this.exemption.pressureInTheTank  = null;
    this.exemption.marvSetting  = '';
    this.exemption.boilOffControlManagement  = '';
    this.exemption.controlMeasuresTaken  = '';
  }

  resetFieldsRelateToRepair25MetersOf() {
    this.exemption.hasCertificateIssued = null;
  }

  resetFieldsRelateToRepairingMoreThanSevenDays() {
    this.exemption.thereIsFirefighter = null;
    this.exemption.thereIsPermissionFromTheOwner = null;
    this.exemption.thereIsPlanOfAction = null;
  }
}

